import { SquadJoin } from '#src/components/squad/SquadJoin/index.tsx';

const SquadJoinPage = () => {
  return <SquadJoin />;
};
export default SquadJoinPage;
